module.exports = __webpack_public_path__ + "static/7-dfb853306375ed562d29f613d0d9d13f.jpg";